import React from "react";

export const Footer = () => {
  return <footer className="visually-hidden">Instabug</footer>;
};
